import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable, tap} from 'rxjs';
import {SynchronizationConfiguration, SynchronizationTaskHistory} from './synchronization.reducer';
import {selectConfigs, selectTaskHistories} from './synchronization.selectors';
import {
  createSynchronizationConfiguration,
  loadSynchronizationConfigurations,
  loadTaskHistory,
  scheduleSynchronization
} from './synchronization.actions';

@Injectable({
  providedIn: 'root'
})
export class SynchronizationFacadeService {
  loadFirstTime = true;

  constructor(private store: Store) {
  }

  selectConfigs(): Observable<SynchronizationConfiguration[]> {
    return this.store.select(selectConfigs)
      .pipe(
        tap(configs => {
          if (!configs || configs.length === 0 && this.loadFirstTime) {
            this.store.dispatch(loadSynchronizationConfigurations());
            this.loadFirstTime = false;
          }
        })
      );
  }

  selectTaskHistories(configId: string): Observable<SynchronizationTaskHistory[]> {
    return this.store.select(selectTaskHistories(configId));
  }

  loadTaskHistories(configId: string) {
    this.store.dispatch(loadTaskHistory({configId}));
  }

  scheduleSynchronisation(id: string) {
    this.store.dispatch(scheduleSynchronization({configId: id}));
  }

  createConfiguration(body: Partial<SynchronizationConfiguration>) {
    this.store.dispatch(createSynchronizationConfiguration({body}));
  }
}
